import { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../App";
import ScrollTopButton from "../ScrollTop";
import SidebarProfile from "../SidebarProfile";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilm } from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-paginate";
import '../../styles/profile.css';
import BrianAnimated from "../BrainAnimated";

function ProfileVideos({ style }) {
    const [videos, setVideos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
        const [isPagingLoading, setIsPagingLoading] = useState(false);

    useEffect(() => {
  window.scrollTo(0, 0);

  const getVideosData = async () => {
    setIsLoading(true);

    const token = localStorage.getItem('token');
    const delay = new Promise(resolve => setTimeout(resolve, 2000)); // ⏱️ تأخير 3 ثوانٍ
    const request = axios.get(`${BASE_URL}/api/homework/videos`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    try {
      const [response] = await Promise.all([request, delay]);
      setVideos(response.data.data.filter(video => video !== null));
    } catch (error) {
      console.error("Failed to fetch videos data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  getVideosData();
}, []);


    function formatDate(dateString) {
        try {
            const date = new Date(dateString);
            const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC', numberingSystem: 'arab' };
            const formatter = new Intl.DateTimeFormat('ar-EG', options);
            return formatter.format(date);
        } catch (e) {
            return '';
        }
    }
    
   const handlePageClick = ({ selected }) => {
        setIsPagingLoading(true);
        setTimeout(() => {
            setCurrentPage(selected);
            setIsPagingLoading(false);
        }, 300);
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = videos.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(videos.length / itemsPerPage);
    
    const columns = [
        {
            name: '#',
            selector: (row, index) => offset + index + 1,
            sortable: true,
            width: '60px',
        },
        {
            name: 'اسم الفيديو',
            selector: row => row.title,
            sortable: true,
            grow: 2,
        },
        {
            name: 'مدة الفيديو',
            selector: row => `${row.video_dauration} دقيقة`,
            sortable: true,
            center: true,
        },
        {
            name: 'عدد المشاهدات',
            selector: row => row.noviews,
            sortable: true,
            center: true,
        },
        {
            name: 'تاريخ الإضافة',
            selector: row => formatDate(row.created_at),
            sortable: true,
            center: true,
        },
        {
            name: 'الإجراء',
            cell: row => (
                <Link to={`/videohomework/${row.id}`} className="action-btn-table view">
                    مشاهدة الفيديو
                </Link>
            ),
            center: true,
        },
    ];

    const customStyles = {
        headRow: { style: { fontSize: '0.95rem', fontWeight: '700' } },
        rows: { style: { minHeight: '72px', fontSize: '1.1rem', fontWeight: '500' } },
    };
    
    if (isLoading) {
         return (
 <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
        <div className="loading-course">
          <BrianAnimated/>
        </div>
      </div>
    );
    }

    return (
        <>
            <div className={`profile-page ${style ? 'dark-mode' : ''}`}>
                <SidebarProfile />
                <main className="profile-main-content">
                    <Container fluid>
                        <div className="page-header">
                            <div className="header-icon-wrapper">
                                <FontAwesomeIcon icon={faFilm} />
                            </div>
                            <div className="header-text">
                                <h1>فيديوهات الواجبات</h1>
                                <p>شاهد فيديوهات حل الواجبات للمراجعة والتعلم.</p>
                            </div>
                        </div>
                        <Row>
                            <Col xs={12}>
                                {videos.length > 0 ? (
                                    <div className="table-container-wrapper">
                                       <div className="datatable-wrapper">
                                            {isPagingLoading && (
                                                <div className="table-loading-overlay">
                                                    <Spinner animation="border" variant={style ? 'light' : 'danger'} />
                                                </div>
                                            )}
                                            <DataTable
                                                columns={columns}
                                                data={currentItems}
                                                customStyles={customStyles}
                                                noDataComponent={<div style={{ padding: "24px" }}>لا توجد سجلات لعرضها</div>}
                                            />
                                        </div>
                                        <ReactPaginate
                                            previousLabel={'السابق'}
                                            nextLabel={'التالي'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination-container'}
                                            pageLinkClassName={'pagination-link'}
                                            previousLinkClassName={'pagination-link prev-next'}
                                            nextLinkClassName={'pagination-link prev-next'}
                                            breakLinkClassName={'pagination-link'}
                                            activeClassName={'pagination-active'}
                                            disabledClassName={'pagination-disabled'}
                                        />
                                    </div>
                                ) : (
                                     <div className="no-content-container">
  <div className="icon-wrapper-not">
    <span className="icon-line line-1"></span>
    <span className="icon-line line-2"></span>
  </div>
                                        <h2> لسه مفيش اي فيديوهات اتفحت ليك </h2>
                                        <p>     سيتم ابلاغك في حين فتح فيديوهات ليك !   </p>
</div>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </main>
            </div>
            <ScrollTopButton />
        </>
    );
}

export default ProfileVideos;